import React, { useMemo } from 'react';
import styles from './TransportTenantBtn.module.scss';
import { ReactComponent as CarIcon } from '../../../../../../../resource/Car.svg';
import { Icon, message, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { openTransportsModal } from '../../../../../store/actions/housingStockActions';
import { useRouteMatch } from 'react-router-dom';

const getId = (value) => {
  const id = Number(value);

  return !isNaN(id) ? id : undefined;
};

const TransportTenantBtn = ({ tenant, addressId, ...props }) => {
  const dispatch = useDispatch();

  const { AllowClientTransport } =
    useSelector((state) => state.authentication.userInfo) || {};

  const { params } = useRouteMatch();

  const houseId = useMemo(() => getId(params.pageId), [params.pageId]);

  const hasTransports = !!tenant?.transports?.length;

  const menuIconStyle = {
    fontSize: 24,
    color: hasTransports ? '#0995ed' : '#888',
    marginRight: 0,
  };

  const handleOpenModal = () => {
    if (!AllowClientTransport) {
      message.warning(
        'У вас нет доступа к списку транспортных средств. Обратитесь в поддержку'
      );
      return;
    }

    dispatch(
      openTransportsModal({
        visible: true,
        tenant: tenant,
        houseId: Number(houseId),
        addressId,
      })
    );
  };

  return (
    <Tooltip
      title={
        hasTransports
          ? 'Транспортные средства'
          : 'Добавить транспортное средство'
      }
    >
      <div
        className={styles.root}
        onClick={handleOpenModal}
        {...props}
      >
        <Icon
          component={CarIcon}
          style={menuIconStyle}
        />
      </div>
    </Tooltip>
  );
};

export default TransportTenantBtn;
